import React from 'react';

import AddBox from '@material-ui/icons/AddBox';
import Check from '@material-ui/icons/Check';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';

import { SvgIconProps } from '@material-ui/core/SvgIcon';

const tableIcons: any = {
  Add: () => <AddBox style={{ color: 'rgb(9, 43, 74)' }}/> as React.ReactElement<SvgIconProps>,
  Check: () => <Check style={{ color: 'green' }}/> as React.ReactElement<SvgIconProps>,
  Clear: () => <Clear style={{ color: 'red' }} /> as React.ReactElement<SvgIconProps>,
  Delete: () => <DeleteOutline /> as React.ReactElement<SvgIconProps>,
  Edit: () => <Edit /> as React.ReactElement<SvgIconProps>
};

export default tableIcons;